import { useSelector } from 'react-redux'

import { DEFAULT_AVATAR_NAME } from 'app/constants/avatar'
import { Avatar } from 'app/components'
import { TriangleAvatarsFormation } from 'app/containers/widget/launcher/components'
import { RaychatLogo } from 'app/components/icons'
import styles from './styles.module.scss'

const getDirection = ({ widgetData }) => widgetData.widgetInfo.languageInfo.general.direction

/**
   * logic of showing department logo:

    1- if custom logo set show item
    2- if not any custom logo is set but operators number is more than 3 then show operators avatar in triangle form
    3- if none of above conditions met then show Raychat logo as default
   */
function DepartmentLogo({ operators, logo, name, showTooltip = false }) {
  // checks if any custom image is set by customer or not
  const isCustomDepartmentLogoSet = logo && !logo.includes(DEFAULT_AVATAR_NAME)
  const direction = useSelector(getDirection)

  const getTooltipDirection = () => {
    if (direction === 'ltr') {
      return 'right'
    }

    return 'left'
  }

  const getAvatarsList = () => {
    return operators.slice(0, 3).map((op) => ({
      id: op.id,
      content: (
        <Avatar
          avatarInfo={{
            url: op.avatar,
            name: op.name,
          }}
          showTooltip={showTooltip}
          tooltipDistanceFromAvatar={5}
          tooltipDirection={getTooltipDirection()}
        />
      ),
    }))
  }

  if (isCustomDepartmentLogoSet) {
    return (
      <Avatar
        borderRadius="12px"
        avatarInfo={{
          url: logo,
          name,
        }}
        backgroundSize={44}
        showTooltip={showTooltip}
      />
    )
  }

  if (operators?.length >= 3) {
    return <TriangleAvatarsFormation avatars={getAvatarsList()} />
  }

  return <RaychatLogo className={styles.raychat_logo} />
}

export default DepartmentLogo
